import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { UeBreadcrumb } from "../components/UeBreadcrumb";
import { UeExplainer } from "../components/UeExplainer";
import { UrlTool } from "../components/UrlTool";

export function UrlEncoderPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <UeBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.ue_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.ue_intro()}
          </p>
        </header>

        <UrlTool />

        <UeExplainer
          howTo={m.ue_howto()}
          faqs={[
            { q: m.ue_faq1_q(), a: m.ue_faq1_a() },
            { q: m.ue_faq2_q(), a: m.ue_faq2_a() },
            { q: m.ue_faq3_q(), a: m.ue_faq3_a() },
            { q: m.ue_faq4_q(), a: m.ue_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
